import { render, staticRenderFns } from "./CardVotantesRepetidos.vue?vue&type=template&id=7dc70a72&scoped=true"
import script from "./CardVotantesRepetidos.vue?vue&type=script&lang=js"
export * from "./CardVotantesRepetidos.vue?vue&type=script&lang=js"
import style0 from "./CardVotantesRepetidos.vue?vue&type=style&index=0&id=7dc70a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc70a72",
  null
  
)

export default component.exports